function getExposureData(userInfo = null) {
  let exposureData = {}

  // 如果有用户信息,添加用户相关字段
  if (userInfo) {
    exposureData = {
      public_id: userInfo.public_id,
      age: userInfo.age,
      gender: userInfo.gender === 1 ? '男' : '女',
      is_high_quality: userInfo.is_high_quality,
      user_level: userInfo.level,
    }
  }

  // 获取URL参数中的device_id
  let urlParams = new URLSearchParams(window.location.search)
  let deviceId = urlParams.get('device_id')
  const refer = urlParams.get('refer') || ''

  // 添加device_id
  if (deviceId || (userInfo && userInfo.device_id)) {
    exposureData['device_id'] = deviceId || userInfo.device_id
    exposureData['#distinct_id'] = deviceId || userInfo.device_id
    exposureData['current_url'] = window.location.href
    exposureData['refer'] = refer
  }

  return exposureData
}

// 封装track方法
function trackEvent(userInfo, eventName, additionalData = {}) {
  const baseData = getExposureData(userInfo)
  window.ta.track(eventName, { ...baseData, ...additionalData })
}

export { getExposureData, trackEvent }
